/* BYC 買付フライト — スクロール演出（GSAP + ScrollTrigger）
 * GSAP が読めないときは何もしない（止まった表示のまま崩れない）。
 * 「動きを減らす」設定では画像の寄りと文字の動きを止め、旅程バーの色だけ切り替える。 */
(function () {
  var contexts = new Map();

  function init(root) {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    if (!gsap || !ST || !root || contexts.has(root)) return;
    gsap.registerPlugin(ST);

    var marks = root.querySelectorAll('[data-leg-mark]');
    function setLeg(n) {
      marks.forEach(function (m) {
        var i = parseInt(m.getAttribute('data-leg-mark'), 10);
        m.classList.toggle('is-current', i === n);
        m.classList.toggle('is-past', i < n);
      });
    }
    setLeg(0);

    // 動きを減らす設定では動画を止めて最初のコマを見せる
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('video.bycf-video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // スクロールで再生：スクロールの進み＝動画の再生位置。戻せば巻き戻る
    root.querySelectorAll('[data-scrub]').forEach(function (sec) {
      var v = sec.querySelector('video');
      var lines = sec.querySelectorAll('[data-line]');
      if (!v) return;
      function show(p) {
        if (!lines.length) return;
        var i = Math.min(lines.length - 1, Math.floor(p * lines.length));
        lines.forEach(function (l, k) { l.classList.toggle('is-on', k === i); });
      }
      function dur() { return isFinite(v.duration) ? v.duration : 0; }
      v.pause();
      if (reduce) {
        // 動きを減らす設定：最後のコマ（着地点）を静止画として見せる
        var toEnd = function () { if (dur()) v.currentTime = Math.max(0, dur() - 0.05); };
        if (v.readyState >= 1) toEnd(); else v.addEventListener('loadedmetadata', toEnd, { once: true });
        show(1);
        return;
      }
      var p = v.play(); if (p && p.then) p.then(function () { v.pause(); }).catch(function () {});
      var target = 0, raf = null;
      function seek() { raf = null; if (dur()) v.currentTime = target * Math.max(0, dur() - 0.05); }
      show(0);
      ST.create({
        trigger: sec.querySelector('.bycf-scrub-track'), start: 'top top', end: 'bottom bottom',
        onUpdate: function (st) { target = st.progress; show(st.progress); if (!raf) raf = requestAnimationFrame(seek); }
      });
    });

    var ctx = gsap.context(function () {
      root.querySelectorAll('[data-leg]').forEach(function (sec) {
        var n = parseInt(sec.getAttribute('data-leg'), 10);
        ST.create({
          trigger: sec, start: 'top 55%', end: 'bottom 55%',
          onToggle: function (st) { if (st.isActive) setLeg(n); }
        });
      });

      var mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', function () {
        root.querySelectorAll('.bycf-scene').forEach(function (sec) {
          var img = sec.querySelector('.bycf-img');
          if (!img) return;
          gsap.fromTo(img, { scale: 1.22, yPercent: -4 }, {
            scale: 1.02, yPercent: 3, ease: 'none',
            scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
          });
        });
        root.querySelectorAll('[data-reveal]').forEach(function (el) {
          var centered = getComputedStyle(el).transform !== 'none' && /--(left|right)/.test(el.className);
          if (centered) gsap.set(el, { clearProps: 'transform', yPercent: -50 });
          gsap.from(el, {
            opacity: 0, y: 32, duration: 0.4, ease: 'power2.out',
            scrollTrigger: { trigger: el, start: 'top 80%', once: true }
          });
        });
      });
    }, root);

    contexts.set(root, ctx);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ST.refresh(); });
  }

  function destroy(root) {
    var ctx = contexts.get(root);
    if (ctx) { ctx.revert(); contexts.delete(root); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bycf]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // テーマエディタでの再読み込みに対応
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-bycf]').forEach(destroy);
  });
})();
